import { useEffect } from 'react';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Image } from 'foundations-components/transitional/components/Image';
import { REMOVE_BRANDING_BANNER } from '../../_core/common/constants/PurchaseMotionLocations';
import { track } from '../../_core/common/eventTracking/tracker';
import { PRICING_PAGE_REDIRECT } from '../../_core/purchaseMotions/PurchaseMotionTypes';
import { getUpgradeDataFromUpgradeConfig } from '../../_core/utils/getUpgradeDataFromUpgradeConfig';
import UIPurchaseMotionButton from '../../button/UIPurchaseMotionButton';
import { getUpgradeConfigTrackingProperties, updateViewedUpgradePointsCache } from '../utils';
import DefaultBanner from './DefaultBanner';

// @ts-expect-error bend url doesn't support types
import sprocketWhite from 'bender-url!../../img/white_sprocket.svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LogoBackground = styled.div.withConfig({
  displayName: "RemoveBrandingBannerWithBadge__LogoBackground",
  componentId: "c4eoeu-0"
})(({
  theme
}) => ({
  background: `linear-gradient(to right, #ff5c35 26px, #fff 26px)`,
  borderTopLeftRadius: theme.borderRadius['100'],
  borderBottomLeftRadius: theme.borderRadius['100'],
  minWidth: theme.space['600'],
  minHeight: theme.space['600'],
  alignItems: 'center'
}));
const RemoveBrandingBannerWithBadge = ({
  upgradePoint,
  marginStyle,
  title,
  'data-test-id': dataTestId = 'locked-feature-banner'
}) => {
  const upgradeData = getUpgradeDataFromUpgradeConfig(upgradePoint);
  useEffect(() => {
    updateViewedUpgradePointsCache(upgradePoint.upgradeKey, () => {
      track('interaction', Object.assign({
        action: 'viewed upgrade point'
      }, getUpgradeConfigTrackingProperties(upgradePoint)));
    });
  }, [upgradePoint]);
  return /*#__PURE__*/_jsx(DefaultBanner, {
    marginStyle: marginStyle,
    dataTestId: dataTestId,
    replacementIcon: /*#__PURE__*/_jsxs(Flex, {
      borderColor: "border-core-default",
      borderWidth: "100",
      borderRadius: "200",
      borderStyle: "solid",
      marginInlineEnd: "400",
      children: [/*#__PURE__*/_jsx(LogoBackground, {
        children: /*#__PURE__*/_jsx(Image, {
          src: sprocketWhite,
          role: "img",
          blockSize: "24px",
          padding: "100"
        })
      }), /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        paddingInline: "100",
        paddingBlock: "0",
        borderRadius: "200",
        borderStartStartRadius: "0",
        borderEndStartRadius: "0",
        backgroundColor: "fill-surface-default",
        inlineSize: "max-content",
        children: /*#__PURE__*/_jsx(Text, {
          color: "temp-do-not-use-specialty-scrim",
          typography: "heading-25",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.removeBrandingBanner.bannerButton"
          })
        })
      })]
    }),
    titleText: title,
    subtext: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "upgrades.removeBrandingBanner.subtitle"
    }),
    button: /*#__PURE__*/_jsx(UIPurchaseMotionButton, {
      upgradeData: upgradeData,
      location: REMOVE_BRANDING_BANNER,
      level: 1,
      use: "link",
      purchaseMotions: [PRICING_PAGE_REDIRECT],
      "data-test-id": "upgrade-button",
      isUpgradePoint: true,
      goToUpgradePage: true,
      truncate: false,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.upgradeButton.default"
      })
    })
  });
};
export default RemoveBrandingBannerWithBadge;